module.exports = __webpack_public_path__ + "95a616269fffa24b07797e82bb611896.svg";